<template>
  <div class="payout-btn">
    <a @click="recordExpense" type="button">
      <div class="icon-box">
        <font-awesome-icon class="icon" icon="hand-holding-dollar"/>
      </div>

      Payout
    </a>

    <button id="modal-btn" type="button" style="display: none" data-bs-toggle="modal"
            data-bs-target="#staticExpensePaymentBackdrop"></button>

    <div class="modal fade" id="staticExpensePaymentBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="staticExpensePaymentBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="staticExpensePaymentBackdropLabel">Capture Payout</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeExpenseModal"
                    aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="makePayment">
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="expenseAccounts">Expense Account / Category</label>
                  <v-select id="expenseAccounts" v-model="paymentForm.Expense" :required="!paymentForm.Expense"
                            :options="expenseAccounts"
                            @search="searchExpenseAccounts">
                    <template slot="no-options">
                      <b>Type to search ...</b>
                    </template>
                  </v-select>
                </div>

                <div class="col-md-6">
                  <label for="expenseAccounts">Supplier</label>
                  <v-select id="expenseSupplier" v-model="paymentForm.SupID"
                            :reduce="item=>item.SuppCode"
                            label="SupplierName"
                            :options="suppliers"
                            @search="searchSuppliers">
                    <template slot="no-options">
                      <b>Type to search ...</b>
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4">
                  <div class="form-floating mt-2">
                    <input type="number" step="0.01" class="form-control" required
                           v-model="paymentForm.InclAmount" @input="inputIncl" id="paymentAmount" placeholder="Amount">
                    <label for="paymentAmount">Expense Amount</label>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-floating mt-2" v-if="paymentForm.hasVat">
                    <input type="text" class="form-control"
                           v-model="paymentForm.ExclAmout" @input="inputExcl" id="exclAmount" placeholder="exclAmount">
                    <label for="exclAmount">Exclusive Amount</label>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-switch mt-3 mx-2">
                    <input class="form-check-input m-1" role="switch" v-model="paymentForm.hasVat" type="checkbox"
                           name="flexRadioDefault" id="hasVAT">
                    <label class="form-check-label" for="hasVAT">
                      Expense has VAT
                    </label>
                  </div>
                </div>
              </div>

              <div class="row m-1">
                <label for="paymentDescription">Payout Reason / Description</label>
                <textarea class="form-control" placeholder="Payout Reason / Description" rows="3"
                          required id="paymentDescription" v-model="paymentForm.Reason"/>
              </div>

              <div class="row mt-2 d-flex justify-content-center">
                <button class="btn btn-primary w-50 h-100" type="submit">Process Payment</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CapturePayout',
  beforeMount() {
    this.resetExpenseData();
  },
  data() {
    return {
      isAllowed: false,
      safes: [],
      expenseAccounts: [],
      suppliers: [],
      paymentForm: {}
    }
  },
  methods: {
    makePayment() {
      this.$utils.showLoading();
      this.paymentForm.invoiceNumber = "Till Payment"
      if (this.paymentForm.date.toString().includes('T')) {
        this.paymentForm.date = this.paymentForm.date.toString().replaceAll('T', ' ') + ':00';
      }
      this.paymentForm.SupPayment = !!this.paymentForm.SupID;
      if (!this.paymentForm.hasVat) {
        this.paymentForm.ExclAmout = Number(this.paymentForm.InclAmount);
        this.paymentForm.InclAmount = Number(this.paymentForm.InclAmount);
      }
      return this.$store.dispatch(`capturePayout`, this.paymentForm)
          .then(() => {
            responses.showSuccess(`Payment Successful`)
            document.getElementById("closeExpenseModal").click();
            this.resetExpenseData();
          }).finally(() => this.$utils.hideLoading())
    },

    resetExpenseData() {
      this.safes = [];
      this.expenseAccounts = [];
      this.paymentForm = {
        SupID: null,
        InclAmount: null,
        ExclAmout: null,
        invoiceNumber: null,
        PaidFrom: null,
        date: this.$store.getters.currentTime,
        Store: false,
        hasVat: true,
        SupPayment: false,
        Expense: null,
        Reason: ''
      }
    },

    searchSuppliers(search, loading) {
      loading(true)
      let obj = {
        SupplierName: search,
        tpin: "",
        contact: "",
        Limit: 150,
      };
      return this.$store.dispatch(`searchSuppliers`, obj)
          .then(res => this.suppliers = res)
          .finally(() => loading(false));
    },

    inputIncl() {
      let taxData = this.$store.getters.getZraCategoryByLabel("A");
      let amount = Number(this.paymentForm.InclAmount);
      if (!this.paymentForm.hasVat || !taxData) this.paymentForm.ExclAmout = amount;
      let taxRate = taxData?Number(taxData.TaxRate):0;
      this.paymentForm.ExclAmout = this.$utils.roundAmount(amount / (1 + taxRate));
    },

    inputExcl() {
      let taxData = this.$store.getters.getZraCategoryByLabel("A");
      let amount = Number(this.paymentForm.ExclAmout);
      if (!this.paymentForm.hasVat || !taxData) this.paymentForm.InclAmount = amount;
      let taxRate = taxData?Number(taxData.TaxRate):0;
      this.paymentForm.InclAmount = this.$utils.roundAmount(amount * (1 + taxRate));
    },

    searchSafes(search, loading) {
      loading(true)
      let obj = {
        safeName: search,
        currency: null,
      }
      return this.$store.dispatch(`searchSafes`, obj)
          .then(res => this.safes = res)
          .finally(() => loading(false));
    },

    searchExpenseAccounts(search, loading) {
      loading(true)
      return this.$store.dispatch(`searchExpenseAccounts`, search)
          .then(res => this.expenseAccounts = res)
          .finally(() => loading(false));
    },
    async recordExpense() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, 'PayoutStore');
      if (!isAllowed) return;
      document.getElementById(`modal-btn`).click();
    },
  }
}
</script>
<style lang="scss">
.payout-btn {
  padding: 0;
  border: #f1f1f1 solid 1px;
  border-radius: 5px;
  margin: 0.5em;

  .list-item, a {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    font-size: 20px;
    padding: 10px;
    text-decoration: none;
    color: #1c1c1c;

    .icon-box {
      width: 35px;
      margin-right: 10px;
      display: flex;
      justify-content: center;

      .icon {
        font-size: 25px;
        color: #34373C;
      }
    }

    &:hover, &.router-link-exact-active {
      background: #f1f1f1;
      color: #1e88e5;
      font-weight: 700;

      .icon-box {
        .icon {
          color: #1e88e5;
        }
      }
    }
  }
}
</style>